/**
 * Translates given property text with given locale.
 *
 * @unstable
 */

import { Pipe, PipeTransform } from '@angular/core';

import { PropertyStore } from '@shared/services/property-store.service';

@Pipe({
  name: 'propertyText',
  pure: false,
  standalone: false,
})
export class PropertyText implements PipeTransform {
  transform(value: string, locale: string, propStore: PropertyStore): any {
    return propStore.transform(value, locale);
  }
}
